import { EmptyState } from '../../../shared/components/EmptyState';
import type { SearchEnvelope } from '../api';
import { SearchResultItem } from './SearchResultItem';

interface SearchResultsProps {
  envelope: SearchEnvelope | undefined;
}

export function SearchResults({ envelope }: SearchResultsProps) {
  if (envelope === undefined) return null;
  if (envelope.items.length === 0) {
    return (
      <EmptyState
        title="Nenhum resultado"
        description="Nenhum trecho de transcript corresponde à busca."
      />
    );
  }
  return (
    <ul className="dash-search__results">
      {envelope.items.map((hit) => (
        <li key={hit.segment_id}>
          <SearchResultItem hit={hit} />
        </li>
      ))}
    </ul>
  );
}
